<div class="actions-header Flexbox Flexbox__just-space-around Flexbox__box-align-center Spacebox__tb-mini Spacebox__lr-mini ">
  <div class="fs6_5 ff_CentraleSansBold">Enrolled care pathways</div>
  <gen-add-test 
    [oldStyle]="false"
    (popupTestCreation)="popupTestCreation($event)">
  </gen-add-test>
  <gen-dynamic-modal-loader class="pan-cancer-event-modal" [observableName]="'NEW_TEST_CHANNEL'"></gen-dynamic-modal-loader>
</div>
<ispm-vertical-test-actions-list *ngIf="actionTests$ | async" [tests$]="actionTests$" 
  [currentRevisionId]="currentRevisionId" (testClicked)="selectTest($event)"></ispm-vertical-test-actions-list>   
